// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2i0Gx","image":"Header_image__MzVJN","name":"Header_name__Qz21s","info":"Header_info__dVCxq","infoRow":"Header_infoRow__1LIsp"};